/*
작성일자: 2020-05-06
작성자: KimJinHee

설명: 이 파일에 정의한 상수값에 따라,
     디버그 메시지를 숨기거나, 콘솔에 보이거나 alert으로 보임

배포시 설정
const DEBUG_MODE = CONSOLE_ONLY
const SECRET_MESSAGE_VISIBLE = false

안정화 시 DEBUG_MODE = NO_MESSAGE
*/

// eslint-disable-next-line no-unused-vars
const NO_MESSAGE = 0
const CONSOLE_ONLY = 1
const ALERT = 2

// const DEBUG_MODE = ALERT
const DEBUG_MODE = CONSOLE_ONLY
// 로그인 토큰, 아이디, 비번을 보여줄지는 정함
// 배포판에서는 보안상 절대로 보여줘서는 안 되므로 false로 올려야 함
// export const SECRET_MESSAGE_VISIBLE = true
export const SECRET_MESSAGE_VISIBLE = false

export function debugMessage(message) {
  switch (DEBUG_MODE) {
    case CONSOLE_ONLY:
      return console.log(message)
    case ALERT:
      console.log(message)
      return alert(message)
  }
}

export function secretDebugMessage(secretMessage) {
  if (SECRET_MESSAGE_VISIBLE) {
    debugMessage(secretMessage)
  }
}
